import React, { useEffect, useRef } from "react";

import Icon from "../assets/submitted.svg";
import FB from "../assets/facebook.svg";
import IG from "../assets/instagram.svg";
import TW from "../assets/twitter.svg";
import { LeadScores } from "../lead_score";
import { salesAssignments, salesReps } from "../config";

function computeSalesAssignment({ country, state }) {
  return salesReps[salesAssignments[country][state || "_default"]];
}

function SchedulerBlock({ schedulerLink }) {
  return (
    <div className="cta-block">
      <p>
        Um deine Anfrage zu bearbeiten und deine Gemeinschaft besser
        kennenzulernen, würden wir gerne mit dir telefonieren.
      </p>
      <p>Klicke den Link, um einen Telefontermin mit uns zu vereinbaren.</p>
      <a className="button" target="_blank" href={schedulerLink}>
        Jetzt Telefontermin vereinbaren
      </a>
    </div>
  );
}

function PresentToTopRoleBlock({ schedulerLink }) {
  const href = `http://www.stickerstars.de/zeig-es-deinem-vorstand?scheduler_link=${schedulerLink}`;

  return (
    <div className="cta-block">
      <p>
        Du hast soeben eine Mail von uns erhalten mit allen Infos zum weiteren
        Vorgehen.
      </p>
      <p>
        Schau gerne auf unserer <b>"Zeig's deinem Vorstand"-Seite</b> vorbei und
        leite den Link an deine Kontaktperson im Verein oder der Feuerwehr
        weiter.
      </p>
      <a className="button" target="_blank" href={href}>
        Zeig's deinem Vorstand
      </a>
    </div>
  );
}

function MessageBlock({ leadScore, schedulerLink }) {
  if ([LeadScores.A_LEAD, LeadScores.B_LEAD].includes(leadScore)) {
    return <SchedulerBlock schedulerLink={schedulerLink} />;
  }

  if (leadScore === LeadScores.D_LEAD) {
    return <PresentToTopRoleBlock schedulerLink={schedulerLink} />;
  }

  return <p>Wir werden uns schnellstmöglich bei dir melden!</p>;
}

const Submitted = ({ leadScore, organization }) => {
  const { schedulerLink } = computeSalesAssignment(organization) || {};
  const contentRef = useRef();

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="submitted">
      <img src={Icon} alt="Form submitted icon" />
      <div className="content" ref={contentRef}>
        <h4>Super!</h4>
        <p>Deine Nachricht hat uns sicher erreicht.</p>
        <div className="message">
          <MessageBlock leadScore={leadScore} schedulerLink={schedulerLink} />
        </div>
        <h2>
          Schau dir an, wie andere
          <br />
          ins Sammelfieber gestartet sind!
        </h2>
        <div className="row social-row">
          <div className="col-1">
            <a
              href="https://facebook.com/stickerstars"
              target="_BLANK"
              rel="noopener noreferrer"
            >
              <img src={FB} className="social-logo" />
            </a>
            <p>Facebook</p>
          </div>
          <div className="col-1">
            <a
              href="https://twitter.com/stickerstarshq"
              target="_BLANK"
              rel="noopener noreferrer"
            >
              <img src={TW} className="social-logo" />
            </a>
            <p>Twitter</p>
          </div>
          <div className="col-1">
            <a
              href="https://instagram.com/stickerstars"
              target="_BLANK"
              rel="noopener noreferrer"
            >
              <img src={IG} className="social-logo" />
            </a>
            <p>Instagram</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Submitted;
